<template>
  <div class="grid md:grid-cols-2 gap-10">
    <!-- <div v-for="(testimonial, index) in initData.testimonialImages" :key="index">
      <img :src="testimonial" class="w-full mx-auto" />
    </div> -->
    <div
      v-for="(testimonial, index) in testimonialsData"
      :key="index"
      class="p-5 rounded-lg"
      style="background: #d8eeff"
    >
      <div class="flex space-x-2 items-center">
        <img :src="testimonial.image" alt="" class="w-24 h-24 rounded-full" />
        <div class="">
          <h2 class="text-xl">{{ testimonial.name }}</h2>
          <p v-if="testimonial.schoolInfo" class="text-sm">
            {{ testimonial.schoolInfo }}
          </p>
          <div class="flex">
          <span v-for="star in testimonial.rating" :key="star">
          <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="w-5 h-5"
            >
              <path
                fill-rule="evenodd"
                d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"
                clip-rule="evenodd"
              ></path>
            </svg>
          </span>
          </div>
        </div>
      </div>
      <p class="mt-5" v-html="testimonial.description">
      </p>
    </div>
    <!-- <div class="bg-gray-200 rounded-lg shadow-xl p-5 relative testimonial">
                <div class="w-full p-8 rounded-lg border-2 border-purple-600 relative">
                    <p>{{ testimonial.text }}</p>
                    <div
                         class="w-16 h-8 transform rotate-180 bg-gray-200 flex justify-center items-center absolute top-0 left-0 -mt-4 ml-4">
                        <svg class="w-8 fill-current text-purple-600"
                             version="1.1"
                             xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink"
                             x="0px"
                             y="0px"
                             viewBox="0 0 198 198"
                             style="enable-background:new 0 0 198 198;"
                             xml:space="preserve">
                            <g>
                                <path d="M0,92.905h48.024c-0.821,35-10.748,38.973-23.216,40.107L20,133.608v38.486l5.542-0.297
                      c16.281-0.916,34.281-3.851,46.29-18.676C82.359,140.125,87,118.893,87,86.3V25.905H0V92.905z">
                                </path>
                                <path d="M111,25.905v67h47.383c-0.821,35-10.427,38.973-22.895,40.107L131,133.608v38.486l5.222-0.297
                      c16.281-0.916,34.442-3.851,46.451-18.676C193.199,140.125,198,118.893,198,86.3V25.905H111z">
                                </path>
                            </g>
                        </svg>
                    </div>
                </div>
            </div>
            <div class="md:px-12 flex md:justify-end mt-10">
                <div class="flex space-x-6">
                    <div>
                        <p v-if="testimonial.schoolInfo">{{ testimonial.schoolInfo }}</p>
                        <p class="text-xl font-semibold">{{ testimonial.school }}</p>
                    </div>
                    <img :src="testimonial.schoolImage"
                         class="w-20"
                         alt="">
                </div>
            </div> -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: {
    initData: {
      default() {
        return {
          testimonialImages: [],
        };
      },
    },
  },

  data() {
    return {
      testimonialsData: [],
    };
  },
  computed: {
    // testimonials() {
    //   return this.testimonialsData;
    // },
    // this.initData.testimonialApi;
  },
  mounted() {
    // const product = this.initData.productName;
    // const finalProduct = this.initData.productName==='SATs Companion' ? 'satscompanion':'mirodoeducation';
    // axios.get(`https://${finalProduct}.com/api/testimonials`)
    // .then((res)=>{
    //   this.testimonialsData=res.data.data;
    // })

    axios.get(this.initData.testimonialApi)
     .then((res)=>{
      this.testimonialsData=res.data.data;
    })
  },
  //computed: {
    // testimonials() {
    //   return [
    //     {
    //       text:
    //         this.initData.productName +
    //         " has been an important tool to help identify misconceptions and provide intervention when needed. The way that it is set up means that it has meant less work for teachers, less planning and a smaller work load. It is interactive, so as teachers you can see what children have been unsure about, this means targeting misconceptions is alot easier!",
    //       school: "Northern Education Trust",
    //       schoolInfo: "Colum Donaghy, Year 6 Teacher",
    //       schoolImage:
    //         "https://cdn.satscompanion.com/school/logos/ysz6UfeBc6XGVjhyp2Td8OmVRoLVcJXxQ3oOxcXd.png",
    //     },
    //     {
    //       text:
    //         "One of the main strength of Mirodo is it's videos. These are clear and engaging, with worked examples and a useful summary. It is both teacher and child friendly and although it is asthetically pleasing, it does not distract from the mathematical understanding.",
    //       school: "Mathematical Association",
    //       schoolInfo: "",
    //       schoolImage:
    //         "https://cdn.satscompanion.com/school/logos/mathematical-association.gif",
    //     },
    //   ];
    // },
  //},

  watch: {},
};
</script>
